'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, ReactNode, useContext } from 'react';
type VastAdStateContextValue = {
  adActive: boolean;
};
const VastAdStateContext = createContext<VastAdStateContextValue>({
  adActive: false
});
type VastAdStateProviderProps = {
  adActive: boolean;
  children: ReactNode;
};
export function VastAdStateProvider(t0) {
  const $ = _c(5);
  const {
    adActive,
    children
  } = t0;
  let t1;
  if ($[0] !== adActive) {
    t1 = {
      adActive
    };
    $[0] = adActive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <VastAdStateContext.Provider value={t1}>{children}</VastAdStateContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function useVastAdState() {
  return useContext(VastAdStateContext);
}